import React from 'react';
import clsx from 'clsx';

import { StudentLoanCopy } from 'components/StudentLoanForgiveness/studentLoanCopy';
import { StudentLoanRow } from 'components/StudentLoanForgiveness/studentLoanFormat';

import styles from './Common.module.scss';

export const InfoNote = ({ title, body }: StudentLoanCopy) => (
  <div className={styles.infoNote}>
    <b>{title}</b> {body}
  </div>
);

export const SavingsHeadline = ({ amount }: { amount: string }) => (
  <div className={styles.savings}>
    <div className={styles.savingsLabel}>Estimated savings</div>
    <div className={styles.savingsAmount}>{amount}</div>
  </div>
);

const Rows = ({ rows }: { rows: StudentLoanRow[] }) => (
  <>
    {rows.map(({ label, value, isStrong }) => (
      <div key={label} className={styles.row}>
        <span>{label}</span>
        <span className={clsx(styles.value, isStrong && styles.strong)}>{value}</span>
      </div>
    ))}
  </>
);

export const PaymentSummary = ({ amount, rows }: { amount: string; rows: StudentLoanRow[] }) => (
  <div className={styles.summary}>
    <div className={styles.summaryAmount}>
      {amount} <small>/mo to start</small>
    </div>
    <Rows rows={rows} />
  </div>
);

export const DetailsCard = ({ title, rows }: { title: string; rows: StudentLoanRow[] }) => (
  <div className={styles.detailsCard}>
    <div className={styles.detailsTitle}>✓ {title}</div>
    <Rows rows={rows} />
  </div>
);

export const Checklist = ({ title, items }: { title: string; items: string[] }) => (
  <div className={styles.checklist}>
    <p className={styles.checklistTitle}>{title}</p>
    {items.map((item) => (
      <div key={item} className={styles.checklistItem}>
        <span className={styles.checkmark}>✓</span>
        <span>{item}</span>
      </div>
    ))}
  </div>
);

export const Callout = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.callout}>{children}</div>
);

export const StepList = ({ steps }: { steps: StudentLoanCopy[] }) => (
  <div className={styles.stepList}>
    {steps.map(({ title, body }, index) => (
      <div key={title} className={styles.step}>
        <div className={styles.stepNumber}>{index + 1}</div>
        <div className={styles.stepContent}>
          <span className={styles.stepTitle}>{title}</span>
          <span className={styles.stepBody}>{body}</span>
        </div>
      </div>
    ))}
  </div>
);
